import React, { useEffect, useState } from 'react';

import { StudioApplicationBase, StudioApplicationStatusEnumBased, WidgetEditorErrorActions } from 'jamespot-user-api';

import { JRCButton } from 'components/JRCButton/JRCButton';

import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { CSSItemIcon, CSSItemLabel, CSSListItem } from '../../JRCWidgetDatasourceTableEditor.styles';
import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetDatasourceContext } from '../../JRCWidgetDatasourceTableEditor';

export const StudioEditorApp = ({
    idApp,
    status,
    onHandleSelection,
}: {
    idApp: string;
    status: StudioApplicationStatusEnumBased;
    onHandleSelection: (app: StudioApplicationBase) => void;
} & WidgetEditorErrorActions) => {
    const [app, setApp] = useState<StudioApplicationBase | undefined>(undefined);
    const { handlers } = useEditorContext<WidgetDatasourceContext>();
    useEffect(() => {
        handlers.jamespot.application &&
            handlers.jamespot.application
                .studioGet(idApp, status)
                .then((response) => {
                    setApp(response.result);
                })
                .catch(handlers.handleCatch)
                .finally(handlers.handleFinally);
    }, [idApp, status, handlers]);

    return app ? (
        <CSSListItem isActive={true}>
            <CSSItemIcon backgroundColor={app.color ?? ''}>
                <JRCIcon name={`icon-${app.icon}`} color={'white'} />
            </CSSItemIcon>
            <CSSItemLabel>{app.label}</CSSItemLabel>
            <JRCButton
                label="WIDGET_Datasource_Select_Source"
                variant={'outlined'}
                onClick={() => onHandleSelection(app)}
            />
        </CSSListItem>
    ) : (
        <></>
    );
};
